"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _index = require("../index.js");
var _PermissionForm = _interopRequireDefault(require("../PermissionForm"));
var _pawnsByRole = _interopRequireDefault(require("./pawnsByRole.graphql"));
var _pawnsByRoleAsSuper = _interopRequireDefault(require("./pawnsByRoleAsSuper.graphql"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Fortress = window.cccisd.fortress;
var AppDefs = window.cccisd.appDefs;
var PermissionFormConvertProps = function PermissionFormConvertProps(_ref) {
  var closeModal = _ref.closeModal,
    loadData = _ref.loadData,
    selectedRows = _ref.selectedRows;
  var initialValues = {};
  _index.permissionsData.forEach(function (pData) {
    initialValues[pData.permission] = false;
  });
  return /*#__PURE__*/_react["default"].createElement(_PermissionForm["default"], {
    closeModal: closeModal,
    initialValues: initialValues,
    loadData: loadData,
    pawnIds: selectedRows
  });
};
var AddPawnRule = function AddPawnRule(_ref2) {
  var closeModal = _ref2.closeModal,
    loadData = _ref2.loadData;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRole = _useState2[0],
    setSelectedRole = _useState2[1];
  var appdefRoles = AppDefs.pawn.roles || [];
  appdefRoles = appdefRoles.filter(function (r) {
    return r.isFortressUser && !['respondent'].includes(r.handle);
  });
  var baseColumns = [{
    name: 'user.username',
    label: 'Username',
    sort: true,
    filter: true
  }, {
    name: 'user.firstName',
    label: 'First Name',
    sort: true,
    filter: true
  }, {
    name: 'user.lastName',
    label: 'Last Name',
    sort: true,
    filter: true
  }, {
    name: 'parentGroup.anyGroup.group.label',
    label: 'Group',
    sort: true,
    filter: true
  }];
  var importantColumns = [];
  var roleDef = appdefRoles.find(function (item) {
    return item.handle === selectedRole;
  }) || {};
  var importantFields = roleDef.importantFields || [];
  var _iterator = _createForOfIteratorHelper(importantFields),
    _step;
  try {
    var _loop = function _loop() {
      var f = _step.value;
      if (baseColumns.find(function (c) {
        return c.name === f.path;
      })) {
        return "continue";
      }
      importantColumns.push({
        name: "important.".concat(f.path),
        label: f.label,
        sort: true,
        filter: true
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (_ret === "continue") continue;
    }

    /* /////////////////////////////////////////////////////////////////////////
    // RENDER-RELATED /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var roleSelector = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "control-label"
  }, "Select Role"), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
    data: [{
      label: '--- Choose a Role ---',
      handle: ''
    }].concat(_toConsumableArray(appdefRoles)),
    itemComponent: function itemComponent(_ref3) {
      var item = _ref3.item;
      return item.label;
    },
    onChange: function onChange(r) {
      setSelectedRole(r.handle);
    },
    value: selectedRole,
    valueComponent: function valueComponent(_ref4) {
      var item = _ref4.item;
      return item && item.label || null;
    },
    valueField: "handle"
  }));
  var renderTable = function renderTable(_ref5) {
    var renderDefault = _ref5.renderDefault,
      selectedRows = _ref5.selectedRows;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderDefault(), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].fieldSpacing
    }, /*#__PURE__*/_react["default"].createElement(PermissionFormConvertProps, {
      closeModal: closeModal,
      loadData: loadData,
      selectedRows: selectedRows
    })));
  };
  var isSuperUser = Fortress && Fortress.isSuperUser();
  var userTable = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fieldSpacing
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: "permissions",
    columns: [].concat(baseColumns, importantColumns),
    graphqlVariables: {
      roleHandle: selectedRole
    },
    query: isSuperUser ? _pawnsByRoleAsSuper["default"] : _pawnsByRole["default"],
    render: renderTable,
    rowActions: [{
      name: 'addRule',
      action: function action() {}
    }],
    rowKey: "pawn.pawnId",
    showRowActions: false
  }));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, roleSelector, selectedRole && userTable);
};
AddPawnRule.propTypes = {
  closeModal: _propTypes["default"].func,
  loadData: _propTypes["default"].func
};
var _default = AddPawnRule;
exports["default"] = _default;